import { useMutation } from '@tanstack/react-query';

import {
  type Notes_UpsertNote,
  gqlClient,
  graphql,
  queryClient,
  resolveBackendError,
} from '@tyro/api';
import { toast } from '@tyro/core';
import { useTranslation } from '@tyro/i18n';

const upsertNote = graphql(/* GraphQL */ `
  mutation notes_upsertNotes($input: [Notes_UpsertNote]) {
    notes_upsertNotes(input: $input) {
      id
    }
  }
`);

export function useUpsertNote() {
  const { t } = useTranslation(['common']);

  return useMutation({
    mutationFn: async (input: Notes_UpsertNote[]) =>
      gqlClient.request(upsertNote, { input }),
    onSuccess: async (_, [note]) => {
      await queryClient.invalidateQueries();

      toast.success(
        note
          ? t('common:snackbarMessages.updateSuccess')
          : t('common:snackbarMessages.createSuccess'),
      );
    },
    onError: async (error: unknown) => {
      const description = await resolveBackendError(error);
      toast.error(t('common:snackbarMessages.errorFailed'), { description });
    },
  });
}
